// extracted by mini-css-extract-plugin
export var content = "styles-module--content--72e5e";
export var description = "styles-module--description--dd1f4";
export var image = "styles-module--image--fff66";
export var input = "styles-module--input--7131f";
export var label = "styles-module--label--5ef10";
export var price = "styles-module--price--00fe1";
export var radioControl = "styles-module--radioControl--48ad7";
export var title = "styles-module--title--411ad";